import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/v1'
  },
  {
    path: '/v1',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
  },
  {
    path: '/v2',
    name: 'about',
    component: HomeView
  },
]

const router = new VueRouter({
  mode: 'history',
  routes:routes
})

export default router
